import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("b", null, "*Please ensure that all mandatory fields are completed and the Job Description has been attached before submitting for approval", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("b", null, "*For compatible browsers please review this link. If your browser is not compatible it may effect the text you see within multi line text boxes and /or the speed of the people search.", -1);
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import formEight from '@/components/approvalWorkflowForms/advertisingRequirements.vue';
import formOne from '@/components/approvalWorkflowForms/attachmentsForm.vue';
import formSeven from '@/components/approvalWorkflowForms/contractDetails.vue';
import formTwelve from '@/components/approvalWorkflowForms/firstSecondApproval.vue';
import formTwo from '@/components/approvalWorkflowForms/hiringSecondaryDetails.vue';
import formFour from '@/components/approvalWorkflowForms/jobDetails.vue';
import formFive from '@/components/approvalWorkflowForms/organisationDetails.vue';
import formNine from '@/components/approvalWorkflowForms/preEmployment.vue';
import formThree from '@/components/approvalWorkflowForms/recruitmentReason.vue';
import formThirteen from '@/components/approvalWorkflowForms/secondLineApproval.vue';
import formTen from '@/components/approvalWorkflowForms/sercurityForm.vue';
import formEleven from '@/components/approvalWorkflowForms/specialistRoles.vue';
import formSix from '@/components/approvalWorkflowForms/workingHours.vue';
import formLayout from '@/layouts/formLayout.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'step15OfferSLA',
    setup(__props) {
        const store = useStore();
        const formPoint = ref(0);
        const navItemConfig = [
            {
                formPoint: 0,
                name: 'formTwo',
                text: 'Hiring Manager & Secondary Contact Details',
                component: formTwo,
                icon: 'UserIcon',
            },
            {
                formPoint: 1,
                name: 'formThree',
                text: 'Recruitment Reason',
                component: formThree,
                icon: 'LogoutIcon',
            },
            {
                formPoint: 2,
                name: 'formFour',
                text: 'Job Details',
                component: formFour,
                icon: 'EmojiHappyIcon',
            },
            {
                formPoint: 3,
                name: 'formFive',
                text: 'Organisation Details',
                component: formFive,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 4,
                name: 'formSix',
                text: 'Working Hours',
                component: formSix,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 5,
                name: 'formSeven',
                text: 'Contract Details',
                component: formSeven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 6,
                name: 'formEight',
                text: 'Advertising Requirements',
                component: formEight,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 7,
                name: 'formNine',
                text: 'Pre Employment Checks',
                component: formNine,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 8,
                name: 'formTen',
                text: 'Security',
                component: formTen,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 9,
                name: 'formEleven',
                text: 'Specialist Roles',
                component: formEleven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 10,
                name: 'formTwelve',
                text: 'First & Second Line Approval',
                component: formTwelve,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 11,
                name: 'formOne',
                text: 'Attachments',
                component: formOne,
                icon: 'UserCircleIcon',
            },
            {
                formPoint: 12,
                name: 'formThirteen',
                text: 'Second Line Approval',
                component: formThirteen,
                icon: 'UserCircleIcon',
            },
        ];
        const currentNavItem = computed(() => navItemConfig.find((item) => item.formPoint === formPoint.value));
        const setCurrentNavItem = (value) => {
            formPoint.value = value;
        };
        const handleSubmitForm = async (event) => {
            const res = await store.dispatch('leaverForm/saveLeaverFormStep', event);
            if (res)
                formPoint.value++;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(formLayout, {
                "nav-item-config": navItemConfig,
                "current-nav-item": currentNavItem.value,
                "form-point": formPoint.value,
                "form-name": "leaverForm",
                navpoints: false,
                onSetCurrentNavItem: setCurrentNavItem
            }, {
                pageTitle: _withCtx(() => [
                    _createTextVNode("Advert Raised")
                ]),
                pageSubtitle: _withCtx(() => [
                    _hoisted_1,
                    _hoisted_2,
                    _createTextVNode(),
                    _hoisted_3
                ]),
                main: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentNavItem.value?.component), { onSubmitForm: handleSubmitForm }, null, 32))
                ]),
                _: 1
            }, 8, ["current-nav-item", "form-point"]));
        };
    }
});
